import { request } from '../../utility/services/request';
import { Service } from '../base';
import objectToFormData from '../../utility/Utils';
import axios from 'axios';

class CustomConstanciasService extends Service {
	getList(
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) {
		return request(
			'GET',
			`${this.baseUrl}?page=${params?.page || ''}
				${params.per_page ? `&per_page=${params.per_page}` : ''}
				${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`
		);
	}

	getCoincidencias(
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) {
		console.log(params);
		return request(
			'GET',
			`${this.baseUrl}/coincidencias?page=${params?.page || ''}
				${params.per_page ? `&per_page=${params.per_page}` : ''}
				${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`
		);
	}

	getCaidaByFichaId(ficha_id) {
		return request(
			'GET',
			`${this.baseUrl}/expedient-data/${ficha_id}`
		);
	}
	create(values, isFormData) {
		return request('POST', this.baseUrl, values, null, isFormData, {
			responseType: 'blob'
		});
	}

	download(
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		},
		tipo
	) {
		return request(
			'GET',
			`${this.baseUrl}/${tipo}/download?page=${params?.page || ''}
		${params.per_page ? `&per_page=${params.per_page}` : ''}
		${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
		${params.order ? `&order=${params.order}` : ''}
		${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
	`
		);
	}

	handleDownload(
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		},
		tipo
	) {
		const link = document.createElement('a');
		axios
			.get(
				`${this.baseUrl}/download/${tipo}?page=${params?.page || ''}
			${params.per_page ? `&per_page=${params.per_page}` : ''}
			${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
			${params.order ? `&order=${params.order}` : ''}
			${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
	  `,
				{ responseType: 'blob' }
			)
			.then((res) => {
				link.download = `constancias.${tipo}`;
				link.target = '_blank';
				link.href = window.URL.createObjectURL(
					new Blob([res.data], {
						type: `application/${tipo === 'pdf' ? tipo : 'octet/stream'}`
					})
				);
				link.click();
			});
	}

	emitirConstancia(data) {
		let ficha_solicitud_id;
		if (typeof data.data.solicitud.ficha_id !== 'undefined') {
			ficha_solicitud_id = data.data.solicitud.ficha_id;
		} else {
			ficha_solicitud_id = '';
		}
		const body = {
			ficha_id: ficha_solicitud_id,
			solicitud_constancia_id: data.data.solicitud.id
		};
		console.log(ficha_solicitud_id);
		return request(
			'POST',
			`${this.baseUrl}/emitir-constancia`,
			objectToFormData(body),
			null,
			true
		);
	}

	_delete({ id, razon_baja, constancias_ids}) {
		const body = {
			id,
			razon_baja,
			constancias_ids
		};
		return request('DELETE', `${this.baseUrl}/${id}`, objectToFormData(body));
	}

	rehabilitarConstancias({ id, constancias_ids}) {
		const body = {
			constancias_ids
		};
		return request('POST', `${this.baseUrl}/${id}/rehabilitar-constancias`, objectToFormData(body));
	}
}

export default CustomConstanciasService;
